import {Model} from 'vue-mc'

export default class Photo extends Model {
  defaults() {
    return {
      id: null,
      event_id: null,
      filename: null,
      zoom: null,
      thumb: null,
      original: null,
      sponsored: false,
      selected: false,
      active: false,
      in_album: false,
      high_resolution: false,
      search_face: false
    }
  }

  free() {
    return this.sponsored
  }

  downloadImageUrl() {
    if(this.high_resolution) {
      return this.original.replace('/photos/', '/photos/source/')
    } else {
      return this.original;
    }
  }

  addFavorite(parameters) {
    this.selected = true
    const params = Object.assign(parameters, {photo_id: this.id})
    return this.createRequest({
      method: 'POST',
      url: `/api/v2/photo_albums/add_photo`,
      params: params
    }).send()
  }

  removeFavorite(parameters) {
    this.selected = false
    const params = Object.assign(parameters, {photo_id: this.id})
    return this.createRequest({
      method: 'POST',
      url: `/api/v2/photo_albums/remove_photo`,
      params: params
    }).send()
  }

  rekognition(parameters) {
    const params = Object.assign(parameters, {
      photo_id: this.id,
      event_id: this.event_id
    })

    return this.createRequest({method: 'POST',
      url: `/api/v1/face_detection`,
      params: params
    }).send()
  }

  download() {
    return this.createRequest({method: 'GET',
      url: this.original,
      responseType: 'arraybuffer'
    }).send()
  }

  async getImage() {
    return await this.createRequest({method: 'GET',
      url: this.downloadImageUrl(),
      responseType: 'arraybuffer'
    }).send()
  }

  // TODO: Move to a new model Album
  async addToAlbum(albumId) {
    return await this.createRequest({
      method: 'POST',
      url: `/api/v3/albums/${albumId}/add_photo`,
      params: {
        photo_id: this.id
      }
    }).send()
  }

  // TODO: Move to a new model Album
  async removeFromAlbum(albumId) {
    return await this.createRequest({
      method: 'POST',
      url: `/api/v3/albums/${albumId}/remove_photo`,
      params: {
        photo_id: this.id
      }
    }).send()
  }  
}